export default __webpack_public_path__ + "static/media/feature-image5.1ee738aa.png";